import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'
import authOnEnter from 'enrollment-platform/authOnEnter'
import PageWrapper from 'enrollment-platform/PageWrapper'
import EmployeeDetail from './pages/EmployeeDetail'
import RunDetail from './pages/RunDetail'
import RunsList from './pages/RunsList'
import { ENROLLMENT_OVERLAP } from './paths'

const EnrollmentOverlapRoute = {
  path: ENROLLMENT_OVERLAP,
  component: PageWrapper,
  onEnter(
    _nextState: unknown,
    _replace: unknown,
    callback: (err?: unknown) => void
  ) {
    // Platform admins only, for the whole section. The API also answers 403
    // for any other caller.
    authOnEnter({
      allowedRoles: [ROLE_PLATFORM_HIXME_ADMIN],
      callback,
    })
  },
  indexRoute: {
    component: RunsList,
  },
  childRoutes: [
    {
      path: ':runId',
      component: RunDetail,
    },
    {
      path: ':runId/employees/:employeePublicKey',
      component: EmployeeDetail,
    },
  ],
}

export default EnrollmentOverlapRoute
